export default __webpack_public_path__ + "5eda33303756d4f8a6ae71ddeb669011.png";